/**
 * viewMemory — localStorage persistence for last-view navigation state.
 *
 * Stores where the user was so they return to the same view on next login.
 * See: docs/architecture/UX_NAVIGATION_PATTERNS_V2.md §8 Last-View Memory
 */

const KEYS = {
  lastView: 'aif_lastView',
  lastFarmSubView: 'aif_lastFarmSubView',
  lastFieldId: 'aif_lastFieldId',
  chatPinned: 'aif_chatPinned',
  chatCollapsed: 'aif_chatCollapsed',
  activeEnterpriseId: 'aif_activeEnterpriseId',
  activeBetriebId: 'aif_activeBetriebId',
};

/** Save last active top-level tab + optional sub-view + optional fieldId. */
export function saveLastView(tab, subView = null, fieldId = null) {
  try {
    if (tab) localStorage.setItem(KEYS.lastView, tab);
    if (subView) localStorage.setItem(KEYS.lastFarmSubView, subView);
    if (fieldId) localStorage.setItem(KEYS.lastFieldId, fieldId);
  } catch { /* ignore storage errors */ }
}

/** Return last-view state. Safe to call before localStorage is available. */
export function getLastView() {
  try {
    return {
      lastView: localStorage.getItem(KEYS.lastView) || null,
      lastFarmSubView: localStorage.getItem(KEYS.lastFarmSubView) || null,
      lastFieldId: localStorage.getItem(KEYS.lastFieldId) || null,
      chatPinned: localStorage.getItem(KEYS.chatPinned) === 'true',
      chatCollapsed: localStorage.getItem(KEYS.chatCollapsed) === 'true',
      activeEnterpriseId: localStorage.getItem(KEYS.activeEnterpriseId) || null,
      activeBetriebId: localStorage.getItem(KEYS.activeBetriebId) || null,
    };
  } catch {
    return {
      lastView: null, lastFarmSubView: null, lastFieldId: null,
      chatPinned: false, chatCollapsed: false,
      activeEnterpriseId: null, activeBetriebId: null,
    };
  }
}

export function saveChatState(pinned, collapsed) {
  try {
    localStorage.setItem(KEYS.chatPinned, String(pinned));
    localStorage.setItem(KEYS.chatCollapsed, String(collapsed));
  } catch { /* ignore */ }
}

export function saveEnterpriseContext(enterpriseId, betriebId) {
  try {
    if (enterpriseId) localStorage.setItem(KEYS.activeEnterpriseId, enterpriseId);
    if (betriebId) localStorage.setItem(KEYS.activeBetriebId, betriebId);
  } catch { /* ignore */ }
}

/** Clear all view memory (called on logout). */
export function clearViewMemory() {
  try {
    Object.values(KEYS).forEach(k => localStorage.removeItem(k));
  } catch { /* ignore */ }
}
